import { DeleteIconButton } from "../../shared/components/buttons/DeleteIconButton";
import { Controller, useFormContext } from "react-hook-form";
import React from "react";
import { useTheme } from "@mui/material";

export function CompanyImageField(props: {
  formReadonly: boolean
}) {
  const { control, setValue } = useFormContext<any>();
  const theme = useTheme();

  return (
    <Controller
      control={control}
      name="logoUrl"
      render={({ field: { onChange, onBlur, value } }) => (
        <>
          {value &&
            <div style={{ display: "flex", paddingTop: 10, alignItems: "center" }}>
              <img
                src={value}
                alt="logo"
                style={{ width: "150px", height: "auto", objectFit: "contain" }}
              />
              {!props.formReadonly &&
                <DeleteIconButton
                  sx={{ marginLeft: "20px", color: theme.palette.error.light }}
                  onClick={() => {
                    setValue("logoFileId", undefined)
                    onChange('')
                    onBlur()
                  }}
                />
              }
            </div>
          }
        </>
      )}
    />
  )
}
